import { useState } from "react"

//PrimeReact
import { Panel } from "primereact/panel"
import { classNames } from "primereact/utils"

//styles
import myStyles from "../../../../../styles/assessments/ManagementFormulaBuilder.module.css"

export default function FormulaBuilderGroupingPanel({ title, children }) {
  const [showPanelContent, setShowPanelContent] = useState(true)

  return (
    <Panel
      header={title}
      className={classNames(
        myStyles.groupingPanel,
        !showPanelContent ? myStyles.groupingPanelCollapsed : ""
      )}
      toggleable
      collapsed={!showPanelContent}
      onToggle={(e) => {
        setShowPanelContent(!e.value)
      }}
    >
      <div className={classNames(myStyles.operatorTitleLayoutHelp)}>
        {children}
      </div>
    </Panel>
  )
}
